export const LADDER_UTC_TIMESTAMP_KEY = 'ladder_utcTimestamp';

export const TT_LATEST_ZONE_TABLE_NAME = 'TT_LATEST_ZONE_TABLE_NAME';
export const TT_HISTORICAL_ZONES_NAME = 'TT_HISTORICAL_ZONES_NAME';
export const TT_ZONE_PREDICTIONS_NAME = 'TT_ZONE_PREDICTIONS_NAME';
export const TT_DISCORD_USER_TABLE_NAME = 'TT_DISCORD_USER_TABLE_NAME';
export const TT_NOTIFICATION_TOPIC_ARN = 'TT_NOTIFICATION_TOPIC_ARN';

export const TT_DISCORD_SECRETS = 'TTDiscordSecrets';
export const TT_API_PULL_VOUCH_QUEUE = 'TTApiPullVouchQueue'

export const LADDER_QUERY_PARAM = 'ladder';
export const NUM_HOURS_QUERY_PARAM = 'numHours';
export const STARTING_HOUR_QUERY_PARAM = 'startingHour';

export const END_OF_HISTORY_INDEX = 'END_OF_HISTORY_INDEX';

export const API_ROOT = 'https://api.aodhagan.link/terror-tracker';

export const CONFIRMED_TRUST_THRESHOLD = 30;